import { useEffect, useState } from "react";
import { UserPermissions } from "@/entity/types/userPermissions";

export function useUtilisateurs() {
  const [permissions, setPermissions] = useState<UserPermissions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetch("/api/utilisateurs")
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.error || "Erreur lors de la récupération des permissions utilisateur");
        }
        return res.json();
      })
      .then((data) => {
        if (!cancelled) {
          setPermissions(data.data);
        }
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { permissions, loading, error };
}
